import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthContext = createContext({ user: null, login: async () => {}, logout: () => {} });

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("ixirli_token");
    if (!token) {
      setReady(true);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser({ username: r.data.username }))
      .catch(() => localStorage.removeItem("ixirli_token"))
      .finally(() => setReady(true));
  }, []);

  const login = async (username, password) => {
    const { data } = await api.post("/auth/login", { username, password });
    localStorage.setItem("ixirli_token", data.token);
    setUser({ username: data.username });
    return data;
  };

  const logout = () => {
    localStorage.removeItem("ixirli_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, ready }}>{children}</AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
